<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<h2>{{ 'auth.authenticationLog' | translate }}</h2>

<div class='card'>
  <p-table [value]='authLogs'
           [lazy]='true'
           [rows]='30'
           [paginator]='true'
           [totalRecords]='totalRecords'
           (onLazyLoad)='lazyLoad.emit($event)'
           [pageLinks]='9'
           [sortField]='sortField'
           [sortOrder]='-1'
           [rowsPerPageOptions]='[10,20,30]'
           #authTable data-testid="table">

    <ng-template pTemplate='header'>
      <tr>
        <th pSortableColumn='userName'>
          {{ 'auth.username' | translate }}
          <p-sortIcon field='username'></p-sortIcon>
        </th>
        <th [pSortableColumn]="sortField">
          {{ 'auth.loginDate' | translate }}
          <p-sortIcon field='loginDateAndTime'></p-sortIcon>
        </th>
        <th pSortableColumn='ipAddress'>
          {{ 'auth.ipAddress' | translate }}
          <p-sortIcon field='ipAddress'></p-sortIcon>
        </th>
        <th pSortableColumn='operatingSystem'>
          {{ 'auth.operatingSystem' | translate }}
          <p-sortIcon field='operatingSystem'></p-sortIcon>
        </th>
        <th pSortableColumn='browser'>
          {{ 'auth.browser' | translate }}
          <p-sortIcon field='browser'></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th>
          <input pInputText type='text'
                 placeholder="{{'auth.search' | translate}}"
                 [ngStyle]="{'width':'100%'}"
                 (input)="authTable.filter($event.target['value'], 'userName', 'contains')" data-testid="input">
        </th>
        <th>
          <iric-date-range-component [showClear]='true'
                                     [datePattern]="'YYYY-MM-DDTHH:mm:ss'"
                                     [suffix]="'Z'"
                                     (dateSelected)="authTable.filter($event,'loginDateAndTime','equals')">
          </iric-date-range-component>
        </th>
        <th>
          <input pInputText type='text'
                 placeholder="{{'auth.search' | translate}}"
                 [ngStyle]="{'width':'100%'}"
                 (input)="authTable.filter($event.target['value'], 'ipAddress', 'contains')" data-testid="input-2">
        </th>
        <th>
          <input pInputText type='text'
                 placeholder="{{'auth.search' | translate}}"
                 [ngStyle]="{'width':'100%'}"
                 (input)="authTable.filter($event.target['value'], 'operatingSystem', 'contains')" data-testid="input-3">
        </th>
        <th>
          <input pInputText type='text'
                 placeholder="{{'auth.search' | translate}}"
                 [ngStyle]="{'width':'100%'}"
                 (input)="authTable.filter($event.target['value'], 'browser', 'contains')" data-testid="input-4">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate='body' let-authentication>
      <tr>
        <td>{{ authentication.userName }}</td>
        <td>{{ (authentication.loginDateAndTime !== null ? authentication.loginDateAndTime : authentication.loginDate) | date: 'short' }}</td>
        <td>{{ authentication.ipAddress }}</td>
        <td>{{ authentication.operatingSystem }}</td>
        <td>{{ authentication.browser }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

